// The "Privacy" tab of the map's (i) box (WS-73 P3 Task 8; one info box in every style, owner 2026-10-29): one link to
// the map section of Map My Stay's privacy notice, in the map's language (Finnish for fi, English otherwise), opening
// in a new tab. The engine cannot import apps/site, so the two addresses are written here;
// tests/unit/chrome/privacy-line.test.mjs pins them to legalUrl() of apps/site/src/lib/legal.js.
import { html, safeUrl } from '../dom.js';

const PRIVACY = { fi: 'https://www.mapmystay.co/fi/tietosuoja#map', en: 'https://www.mapmystay.co/privacy#map' };

/** @param {string} lang @returns {string} */
export const privacyHref = (lang) => (lang === 'fi' ? PRIVACY.fi : PRIVACY.en);

/**
 * The "Map data" tab's list items: each credit word for word (a licence duty), a link when its href is safe, text otherwise.
 * @param {{ text: string, href?: string }[]} credits
 * @returns {{ toString(): string }} safe markup (dom.js html``), for an html`` template
 */
export function creditItems(credits) {
  const link = (x) => (safeUrl(x.href) ? html`<a href="${safeUrl(x.href)}" target="_blank" rel="noopener">${x.text}</a>` : html`<span>${x.text}</span>`);
  return html`${credits.map((x) => html`<li>${link(x)}</li>`)}`;
}

/**
 * The "Privacy" tab's line: the link to the privacy notice, in the map's language.
 * @param {(key: string) => string} T
 * @param {string} lang
 * @returns {{ toString(): string }} safe markup
 */
export const privacyLine = (T, lang) => html`<a class="credit-privacy" href="${privacyHref(lang)}" target="_blank" rel="noopener">${T('credit.privacy.notice')}</a>`;
